import React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { TrustStats } from './components/sections/TrustStats';
import { Transformation } from './components/sections/Transformation';
import { TaglineCta } from './components/sections/TaglineCta';
import { KeyBenefits } from './components/sections/KeyBenefits';
import { Tomos } from './components/sections/Tomos';
import { ExerciseCardDetail } from './components/sections/ExerciseCardDetail';
import { SystemSteps } from './components/sections/SystemSteps';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { ValueComparison } from './components/sections/ValueComparison';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCTA } from './components/ui/StickyCTA';
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3mjzpuwis6nxl">
      <div className="w-full min-h-full bg-white font-body text-ink" data-id="element-1" data-mp="3rcj5s04xxv5k">
        <main data-id="element-2" data-mp="3recedkz46pg7">
          <Hero data-id="element-3" data-mp="5yk6vxnnffx" />
          <TrustStats data-id="element-4" data-mp="5opww5kum4f" />
          <Transformation data-id="element-5" data-mp="4wxfu7a14id" />
          <TaglineCta data-id="element-6" data-mp="56n1goet9nj" />
          <KeyBenefits data-id="element-7" data-mp="7sxbo2oq39g" />
          <Tomos data-id="element-8" data-mp="2zlldgx6hkckm" />
          <ExerciseCardDetail data-id="element-9" data-mp="2zm4wkh7vh708" />
          <SystemSteps data-id="element-10" data-mp="2zmwh8wzxlkbq" />
          <Bonuses data-id="element-11" data-mp="33mouvo46mgny" />
          <Pricing data-id="element-12" data-mp="33m5ck6amdq9e" />
          <ValueComparison data-id="element-13" data-mp="33nq55qddiz4m" />
          <Testimonials data-id="element-14" data-mp="33mylndx1wrup" />
          <Guarantee data-id="element-15" data-mp="38lrq6gud18iq" />
          <FAQ data-id="element-16" data-mp="38l8eviz7tido" />
          <FinalCTA data-id="element-17" data-mp="38kqafz2efxuo" />
        </main>
        <Footer data-id="element-18" data-mp="38nuodo5o27yj" />
        <StickyCTA data-id="element-19" data-mp="3dkuufz2inapn" />
      </div>
    </LazyMotion>;
}